var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSelfServeSubscription)?_c('CenteredTitleSubtitlePage',{attrs:{"title":"trial-end.no-plan","subtitle":"trial-end.contact-your-administrator"}}):_c('TopTitleSubtitlePage',{attrs:{"title":"trial-end.no-subscription","subtitle":"trial-end.contact-sales","cta-title":"subscription.contact-sales","cta-link":_vm.$t('links.contact-sales')}})
}
var staticRenderFns = []

export { render, staticRenderFns }